import React from 'react';
import { CheckCircle2, Loader2, X } from 'lucide-react';
import { Progress } from '@/components/ui/progress';
import { Button } from '@/components/ui/button';

// ──────────────────────────────────────────────────────────
// Prüf-Fortschritt (Progress indicator) — schlanke Listen-Leiste
// Ampel-Logik: <50 % Amber · <100 % Emerald-400 · 100 % Emerald-600
// ──────────────────────────────────────────────────────────
export function ReviewProgress({ reviewed, total }) {
  if (!total) return null;
  const pct = Math.round((reviewed / total) * 100);
  const barColor = pct >= 100 ? 'bg-emerald-600' : pct >= 50 ? 'bg-emerald-400' : 'bg-amber-500';
  return (
    <div
      className="mb-3 flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-4 py-2.5 shadow-sm"
      data-testid="progress-bar-list"
    >
      <CheckCircle2 className={`h-4 w-4 ${pct >= 100 ? 'text-emerald-600' : 'text-slate-400'}`} strokeWidth={2} />
      <span className="text-sm font-medium text-slate-700 whitespace-nowrap">
        Prüf-Fortschritt
      </span>
      <div className="relative h-2 w-32 overflow-hidden rounded-full bg-slate-100">
        <div
          className={`absolute inset-y-0 left-0 rounded-full transition-all duration-500 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="text-xs font-medium tabular-nums text-slate-500 whitespace-nowrap">
        {reviewed}/{total} · {pct}% geprüft
      </span>
    </div>
  );
}

// ──────────────────────────────────────────────────────────
// Bulk-Aktionsleiste (Floating Action Bar)
// Erscheint zentriert unten, sobald ≥1 Position ausgewählt ist.
// ──────────────────────────────────────────────────────────
export function BulkActionBar({ count, onVerify, onCancel, loading }) {
  if (count <= 0) return null;
  return (
    <div
      className="fixed bottom-8 left-1/2 z-50 flex -translate-x-1/2 items-center gap-6 rounded-2xl border border-slate-200 bg-white px-6 py-4 shadow-2xl animate-in slide-in-from-bottom-4 fade-in duration-300"
      data-testid="bulk-action-bar"
    >
      <span className="text-sm font-medium text-slate-700">
        <span className="font-mono">{count}</span> ausgewählt
      </span>
      <div className="flex items-center gap-2">
        <Button
          onClick={onVerify}
          disabled={loading}
          className="rounded-xl bg-emerald-600 text-white hover:bg-emerald-700"
          data-testid="bulk-action-verify"
        >
          {loading ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <CheckCircle2 className="mr-2 h-4 w-4" />
          )}
          Als geprüft markieren
        </Button>
        <Button
          variant="ghost"
          onClick={onCancel}
          disabled={loading}
          className="rounded-xl text-slate-500 hover:text-slate-900"
          data-testid="bulk-action-cancel"
        >
          <X className="mr-1 h-4 w-4" />Auswahl aufheben
        </Button>
      </div>
    </div>
  );
}
